<template>
  <div class="content">
    <div class="mid">
      <div class="title">
        {{ shenPiList.applyMan }}提交的{{ shenPiList.customName }}
      </div>
      <div class="des">
        {{ userDept }}
      </div>
      <div class="des">
        <span v-if="shenPiList.result == 1" style="color: #FF8165;"
        >审核中</span
        >
        <span v-if="shenPiList.result == 2" style="color: #48D25F;">完成</span>
        <span v-if="shenPiList.result == 3" style="color: #ebb563;">撤回</span>
        <span v-if="shenPiList.result == 4" style="color: #FF8165;">拒绝</span>
        <span v-if="shenPiList.result == 7" style="color: #FF8165;">重新提交</span>
      </div>
    </div>
    <!-- <el-descriptions class="title" :column="1">
      <el-descriptions-item>
        {{ shenPiList.customName }}
      </el-descriptions-item>
      <el-descriptions-item label="模板名称">
        {{ shenPiList.tptName }}
      </el-descriptions-item>
      <el-descriptions-item label="模板分组">
        {{ shenPiList.tptGroupName }}
      </el-descriptions-item>
      <el-descriptions-item label="发起人"> </el-descriptions-item>
      <el-descriptions-item label="发起时间">
        {{ shenPiList.applyTime }}
      </el-descriptions-item>
    </el-descriptions> -->

    <div class="form mid" v-if="Show">
      <div class="des">审批编号</div>
      <div class="des" style="color:#1e1e1e">
        {{ shenPiList.instanceId }}
      </div>
      <div class="des" style="margin-top:12px">所在部门</div>
      <div class="des" style="color:#1e1e1e">
        {{ userDept }}
      </div>
      <initiate-process1
          ref="processForm"
          :code="shenPiList.tptId"
          :flag="flag"
          :forms="formData"
          :formPerms="JSON.parse(shenPiList.formPerms)"
      ></initiate-process1>
    </div>
    <!-- v-if="!buttonShow" -->
    <div class="form mid">
      <div class="title">流程</div>
      <el-timeline style="margin: 20px 0px 0 14px;">
        <el-timeline-item
            v-for="(i, index) in processList"
            :key="index"
            :timestamp="i.addTime"
        >
          {{ i.content }}
          <span style="color:#3c87f7" @click="go(i.attacth)" v-if="i.attacth">
            预览附件
          </span>
          <template #dot>
            <span class="Name" style="display: inline-block;">{{
                i.addMan | returnFloat
              }}</span>
            <img
                src="https://points-malls.oss-cn-beijing.aliyuncs.com/goodsImg/ef1c.png"
                alt=""
                style="width: 14px;height: 14px;position: absolute;right: -14%;bottom: -14%;"
            />
          </template>
        </el-timeline-item>
      </el-timeline>

      <!-- 判断当前登录人 -->
      <!--判断是否正在审核中-->
      <div
          class="demo-drawer__footer"
          style="text-align: center; margin: 30px 0 20px"
          v-if="shenPiList.result == 1 && chehuiButton&&processList.length<=1"
      >
        <el-button
            type="warning"
            :loading="submitLoading"
            :disabled="submitLoading"
            @click.native="ceasepost(3)"
        >撤 回
        </el-button
        >
      </div>
      <!-- 拒绝或撤回状态  显示重新发起按钮 -->
      <div
          class="demo-drawer__footer"
          style="text-align: center; margin: 30px 0 20px"
          v-if="(shenPiList.result == 4 || shenPiList.result == 3) && chehuiButton"
      >
        <el-button
            type="primary"
            :loading="submitLoading"
            :disabled="submitLoading"
            @click="againSubmitFun"
        >重新发起
        </el-button
        >
      </div>
    </div>
    <div class="form mid" v-if="flag == 1">
      <div style="margin-bottom: 10px">审批</div>
      <el-form
          :model="dataForm"
          label-width="70px"
          ref="dataForm"
          :rules="dataFormRules"
          label-position="right"
          class="demo-form-inline"
          :inline="true"
          size="mini"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="审批意见" prop="verifyIdea">
              <el-input
                  v-model="dataForm.verifyIdea"
                  type="textarea"
                  autosize
                  style="width: 252px"
                  auto-complete="off"
                  placeholder="请输入审批意见"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
                style="width: 85%;"
                label="附件"
                prop="attacth"
                class="fujian"
            >
              <file-upload1 v-model="dataForm.attacth" :isShowTip="false"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
          class="demo-drawer__footer"
          style="text-align: center; margin: 60px 0 20px"
      >

        <el-button
            v-show="shenPiList.result===6"
            :loading="editLoading"
            type="success"
            @click.native="ceasepost(1)"
        >办理
        </el-button
        >
        <el-button
            v-show="shenPiList.result!==6"
            :loading="editLoading"
            type="success"
            @click.native="ceasepost(1)"
        >同意
        </el-button
        >
        <el-button
            v-show="shenPiList.result!==6"
            :loading="editLoading"
            type="warning"
            @click.native="ceasepost(2)"
        >不同意
        </el-button
        >
        <!-- <el-button
            :loading="editLoading"
            type="danger"
            @click.native="ceasepost(3)"
            >驳回</el-button
          > -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetFlowInstance,
  GetOpeateRecList, goback,
  VerifyInstance,
} from "@/api/design";
import InitiateProcess1 from "./InitiateProcess1";
import config from "@/config/index";
import axios from "axios";

export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {InitiateProcess1},
  // 组件状态值
  data() {
    return {
      activiteId: "",
      instanceId: "",
      editLoading: false,
      userDept: "",
      dataForm: {},
      dataFormRules: {
        Status: [
          {required: true, message: "审核结果不能为空", trigger: "change"},
        ],
      },
      buttonShow: false,
      Show: false,
      formData: [],
      shenPiList: {}, // 审批详情
      processList: [],
      flag: "",
      submitLoading: false,
      chehuiButton: true,
    };
  },
  filters: {
    returnFloat(val) {
      if (val.length <= 2) {
        return val;
      } else {
        return val.slice(-2);
      }
    },
    formatTime(val) {
      return val.split(" ")[0];
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    go(url) {
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/downLoading?url=" + url,
        });
        // }, 100);
      } else {
        alert("请在微信小程序中打开");
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        // this.$router.push(path);
      }
    },
    async getDetail() {
      await GetFlowInstance({instanceId: this.instanceId}).then((res) => {
        this.shenPiList = res.data;
        // 判断当前登录人是否是发起人
        if (this.shenPiList.applyManId == this.$route.params.userId) {
          this.chehuiButton = true
        } else {
          this.chehuiButton = false
        }
        this.getUserInfo();
        this.formData = JSON.parse(this.shenPiList.formData);
        this.formData.forEach((item) => {
          if (item.name === 'NumberInput') {
            item.value = Number(item.value)
          }
        })
        if (this.shenPiList.formData.length > 4) {
          this.Show = true;
        } else {
          this.Show = false;
        }
      });
      GetOpeateRecList({instanceId: this.instanceId}).then((res) => {
        this.processList = res.data;
      });
    },
    async ceasepost(val) {
      this.dataForm.instanceId = this.instanceId;
      this.dataForm.activiteId = this.activiteId;
      this.dataForm.userId = this.$route.params.userId;
      this.dataForm.nickName = this.$route.params.nickName;
      this.dataForm.verifyFlag = val;
      this.dataForm.result = val;
      this.formData.forEach((i) => {
        i.value = this.$store.state.formValue[i.id];
      });
      this.dataForm.formData = JSON.stringify(this.formData);
      console.log(this.dataForm, "dataForm");
      this.editLoading = true;
      // 撤回不用校验
      if (val === 3) {
        this.VerifyFungoBack()
      } else {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            this.VerifyFun()
          }
        });
      }
    },
    async VerifyFun() {
      await VerifyInstance(this.dataForm);
      this.editLoading = false;
      this.$message({message: "操作成功", type: "success"});
      window.history.back();
    },
    async VerifyFungoBack() {
      await goback(this.dataForm);
      this.editLoading = false;
      this.$message({message: "操作成功", type: "success"});
      window.history.back();
    },

    // 获取 发起人信息
    getUserInfo() {
      var that = this;
      axios({
        url:
            config.ParentUrl +
            "system/personnel/getDeptNameByUserId?userId=" +
            that.shenPiList.applyManId,
        method: "get",
      }).then((res) => {
        console.log(res.data.msg, "用户所在部门");
        this.userDept = res.data.msg;
      });
    },

    // 重新发起流程
    againSubmitFun() {
      if (this.shenPiList.result === 3 || this.shenPiList.result === 4) {
        var path =
            "/approval/" +
            this.shenPiList.tptId +
            "/" +
            this.$route.params.userId +
            "/" +
            this.shenPiList.platformId +
            "/" +
            this.shenPiList.companyId +
            "/" +
            this.$route.params.nickName+
            "/" +
            this.$route.params.deptId +
            "/" +
            this.shenPiList.customName;
        this.$router.push({
          path: path,
          query: {
            list:this.shenPiList,
            activiteId:this.activiteId,
            instanceId: this.instanceId,
            shenPiListDetail: this.shenPiList.formData,
            againShenPiStaute: this.shenPiList.result,
            isAgainShenPi: true,
          },
        });
      }
    },
  },

  created() {
  },
  mounted() {
    this.instanceId = this.$route.params.instanceId;
    this.activiteId = this.$route.params.activiteId;
    this.flag = this.$route.params.flag;
    this.getDetail();
  },
};
</script>

<style scoped>
.content {
  max-height: 100vh;
  background-color: #f7f7f7;
}

.mid {
  background-color: #fff;
  box-sizing: border-box;
  padding: 13px 14px;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 16px;
  color: #1e1e1e;
  margin-bottom: 12px;
}

.des {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #999999;
  margin: 5px 0 7px;
}

.el-timeline-item {
  padding-bottom: 50px;
}

/deep/ .el-timeline-item__tail {
  /* border-left: 2px solid #397affbf; */
}

/deep/ .el-timeline-item__node {
  background-color: #397aff;
}

/deep/ .el-timeline-item__dot {
  left: -13px;
}

/deep/ .el-timeline-item__tail {
  top: 43px;
  height: 44%;
}

.Name {
  width: 36px;
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  background: #3c87f7;
  color: #fff;
  box-sizing: border-box;
  text-align: center;
}

/deep/ .el-timeline-item__content {
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 13px;
  color: #1e1e1e;
}

/deep/ .el-timeline-item__timestamp {
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 13px;
  color: #999999;
  margin-left: 6px;
}

.fujian /deep/ .el-form-item__content {
  width: 60%;
}
</style>
